module.exports = __webpack_public_path__ + "static/media/lightbulbOff_32.3aa6e1b7.png";